import React, { Component } from 'react';
import { Table } from 'react-bootstrap'
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/logs"

class LogOverzicht extends Component {
    constructor() {
        super()
        this.getLogs = this.getLogs.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.state = {
            logs: [],
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            }
        }
    }

    getLogs(fetchUrl) {
        Api.GetTableApi(fetchUrl, this.handleClick)
            .then(response => {
                Api.print("Response")
                Api.print(response)
                this.setState({ pagination: response.pagination }) // Pagination object 
                return response.data.json() // Data -> logs object
            })
            .then(objectData => {
                Api.print("Logs)")
                Api.print(objectData)
                Api.print("----------")

                if (objectData !== undefined) {
                    let logs = objectData.logs.map((log, index) => {
                        return <tr key={log.id}>
                            <td>{log.message}</td>
                            <td>{Api.formatDate(log.dateTime)}</td>
                            <td>{log.level}</td> </tr>
                    })
                    this.setState({ logs })
                }
            })
    }

    componentDidMount() {
        this.getLogs(FETCH_URL)
    }

    handleClick(e) {
        const fetchUrl = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.getLogs(fetchUrl)
    }

    render() {

        return (
            <div>
                <Table responsive striped bordered hover>
                    <thead>
                        <tr>
                            <th>Bericht</th>
                            <th>Tijdstip</th>
                            <th>Niveau</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.logs}
                    </tbody>
                </Table>
                <div className="paginationStyling">
                <div style={{ float: 'left' }}>
                    {this.state.pagination.prevButton}
                </div>
                <div style={{ float: 'center' }}>
                    Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                </div>
                <div style={{ float: 'right' }}>
                    {this.state.pagination.nextButton}
                </div>
                </div>
                </div>
        );
    }
}

export default LogOverzicht;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Log/Overview.js